import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
export const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    meta: {
      title: "home",
    },
    component: () => import("@/views/home/index.vue"),
  },
  {
    path: "/comment",
    name: "comment",
    meta: {
      title: "comment",
    },
    component: () => import("@/views/home/comment.vue"),
  },
  {
    path: "/skill",
    name: "skill",
    meta: {
      title: "skill",
    },
    component: () => import("@/views/home/mySkill.vue"),
  },
  {
    path: "/onLineTemplate",
    name: "onLineTemplate",
    meta: {
      title: "",
    },
    component: () => import("@/views/onlinetemplate/template.vue"),
  },
  {
    path: "/pipelogin",
    name: "Login",
    meta: {
      title: "手机号验证",
    },
    component: () => import("@/views/pipe/Login.vue"),
  },
  {
    path: "/report",
    name: "Report",
    meta: {
      title: "施工信息",
    },
    component: () => import("@/views/pipe/Report.vue"),
  },
   {
    path: "/checkrecordlist",
    name: "Checkrecordlist",
    meta: {
      title: "安检记录",
    },
    component: () => import("@/views/checkrecordlist/checkrecordlist.vue"),
  },
  // 替代vue2中的'*'通配符路径
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHashHistory(), // history 模式则使用 createWebHistory()
  routes,
});
export default router;
